// extracted by mini-css-extract-plugin
export default {"allocated-credits-cell":"AllocatedCredits_allocated-credits-cell__0lFBi","allocated-credits-value":"AllocatedCredits_allocated-credits-value__9YlLB"};